<template>
  <div id="" class="mainDiv">
    <div class="head clearfix">
      <el-button
        type="primary"
        size="small"
        @click="goBack"
        class="head-li"
        style="float: left"
        >返回</el-button
      >
      <h3 class="head-li" style="text-align: center">
        {{ this.$route.query.edit_style }}
      </h3>
    </div>
    <div class="student-info">
      <div>老师：{{ this.form.uname }}</div>
      <div>状态：{{ this.form.stauts }}</div>
      <div>发布时间：{{ this.form.startDate }}</div>
      <div>截止时间：{{ this.form.endDate }}</div>
    </div>
    <el-form ref="form" :model="form" label-width="140px">
      <el-form-item prop="name" label="作业主题：">
        <p>{{ this.form.topic }}</p>
      </el-form-item>
      <el-form-item label="作业附件：">
        <a
          :href="this.form.homeworkHref"
          class="download"
          v-if="this.form.homeworkAccessory != null"
          >{{ this.form.homeworkAccessory }} 点击下载</a
        >
      </el-form-item>
      <!-- <el-form-item label="作业："></el-form-item> -->
      <el-form-item label="作业：" prop="content" style="position: relative">
        <quill-editor
          ref="quillEditor"
          v-model="form.content"
          :options="options"
          style="width: calc(100% - 40px)"
          oninput="if(value.length > 10000) value=value.slice(0, 20)"
          disabled
        >
          <div id="toolbar" slot="toolbar" style="height: 0; padding: 0"></div>
        </quill-editor>
      </el-form-item>
      <el-form-item label="答题结果：">
        <quill-editor
          ref="quillEditor2"
          v-model="form.answerContent"
          :options="options2"
          oninput="if(value.length > 10000) value=value.slice(0, 20)"
          style="width: calc(100% - 40px)"
        >
          <div id="toolbar2" slot="toolbar">
            <button class="ql-bold" title="加粗">Bold</button>
            <button class="ql-italic" title="斜体">Italic</button>
            <button class="ql-underline" title="下划线">underline</button>
            <button class="ql-strike" title="删除线">strike</button>
            <button class="ql-blockquote" title="引用"></button>
            <button class="ql-code-block" title="代码"></button>
            <button class="ql-list" value="ordered" title="有序列表"></button>
            <button class="ql-list" value="bullet" title="无序列表"></button>
            <button class="ql-indent" value="+1" title="首行缩进">
              indent
            </button>
            <select class="ql-header" title="段落格式">
              <option selected>段落</option>
              <option value="1">标题1</option>
              <option value="2">标题2</option>
              <option value="3">标题3</option>
              <option value="4">标题4</option>
              <option value="5">标题5</option>
              <option value="6">标题6</option>
            </select>
            <select class="ql-size" title="字体大小">
              <option value="10px">10px</option>
              <option value="12px">12px</option>
              <option value="14px">14px</option>
              <option value="16px" selected>16px</option>
              <option value="18px">18px</option>
              <option value="20px">20px</option>
            </select>
            <select class="ql-font" title="字体">
              <option value="SimSun" selected></option>
              <option value="SimHei"></option>
              <option value="Microsoft-YaHei"></option>
              <option value="KaiTi"></option>
              <option value="FangSong"></option>
              <option value="Arial"></option>
              <option value="Times-New-Roman"></option>
              <option value="sans-serif"></option>
            </select>
            <select class="ql-color" value="color" title="字体颜色"></select>
            <select
              class="ql-background"
              value="background"
              title="背景颜色"
            ></select>
            <select class="ql-align" value="align" title="对齐"></select>
            <button class="ql-clean" title="还原"></button>
          </div>
        </quill-editor>
      </el-form-item>

      <el-form-item label="答题附件：" v-if="this.form.attachment === true">
        <el-upload
          v-if="file === ''"
          class="upload-demo"
          :action="url + '/zkfz/zkolHomework/saveStudentAnswer'"
          ref="upload"
          :auto-upload="false"
          accept=".doc,.docx"
          :on-change="handleChange"
          :limit="1"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传word且不超过1个</div>
        </el-upload>
        <el-upload
          v-else
          class="upload-demo"
          :action="url + '/zkfz/notice/saveOrUpdate'"
          ref="upload"
          :auto-upload="false"
          accept=".doc,.docx"
          :on-change="handleChange"
          :limit="1"
          :file-list="[file]"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传word且不超过一个</div>
        </el-upload>
      </el-form-item>
      <el-form-item
        label="退回原因："
        v-if="form.sendbackCause != null && form.sendbackCause != ''"
      >
        <h3
          v-for="(item, index) in this.form.sendbackCause.split('#encryption#')"
          :key="item.id"
        >
          {{ index + 1 }}. {{ item }}
        </h3>
      </el-form-item>
      <el-form-item label-width="0px" style="padding: 20px 0">
        <el-button
          type="primary"
          @click="onSubmit(0)"
          style="margin: 0 20px; width: 98px"
          >保存作业</el-button
        >
        <el-button
          type="primary"
          @click="onSubmit(1)"
          style="margin: 0 20px; width: 98px"
          >提交作业</el-button
        >
        <el-button
          type="primary"
          @click="goBack"
          style="margin: 0 20px; width: 98px"
          >取消</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { confirmMsg } from '@/utils/common'
import * as api from '@/api/homework/homework'
import { Quill, quillEditor } from 'vue-quill-editor' //调用编辑器
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import '@/assets/css/quill.css'

// 自定义字体大小
const Size = Quill.import('attributors/style/size')
Size.whitelist = ['10px', '12px', '14px', '16px', '18px', '20px']
Quill.register(Size, true)

// 自定义字体类型
const fonts = [
  'simSum',
  'SimHei',
  'Microsoft-YaHei',
  'KaiTi',
  'FangSong',
  'Arial',
  'Times-New-Roman',
  'sans-serif',
]
const Font = Quill.import('formats/font')
Font.whitelist = fonts
Quill.register(Font, true)

export default {
  name: 'HomeworkSubmit',
  head: '修改作业',
  components: {
    quillEditor,
  },
  data() {
    return {
      form: {
        name: '',
        content: '',
        ground: '',
        uploadFileList: [],
        submitDate: [new Date(2021, 2, 1, 0, 0), new Date(2021, 2, 1, 0, 0)],
        attachment: 0,
        attachmentSize: '',
        isCheckRepetition: 0,
        staus: 0,
        sendbackCause: '',
      },
      options: {
        placeholder:
          '富文本内容大小不能超过20000字节，图片合集请用压缩包上传附件！',
        theme: 'snow',
        modules: {
          toolbar: '#toolbar',
        },
      },
      options2: {
        placeholder:
          '富文本内容大小不能超过20000字节，图片合集请用压缩包上传附件！',
        theme: 'snow',
        modules: {
          toolbar: '#toolbar2',
        },
      },
      file: '',
      loading: false,
      editBtnStyle: '0',
      showSendback: 0,
      isDisabled: true,
      userType: '',
    }
  },
  methods: {
    getUserByUid() {
      api.getUserByUid(this.getUId).then(({ data }) => {
        console.log(data)
        if (data.code === 100000) {
          this.userType = data.data.type
          this.getdata()
        }
      })
    },
    getdata() {
      let reqdata = {
        homeworkId: this.$route.query.homeworkId,
        answerId: this.$route.query.answerId,
        uid: this.$route.query.studentId,
        userType: this.userType,
      }
      api.getStudentHomeworkInfo(reqdata).then((res) => {
        if (res.data.data != null) {
          this.form = res.data.data
        }
        if (
          this.form.stauts == null ||
          this.form.stauts == '' ||
          this.form.stauts == 0
        ) {
          this.form.stauts = '未提交'
        } else if (this.form.stauts == 1) {
          this.form.stauts = '已提交'
        } else if (this.form.stauts == 2) {
          this.form.stauts = '已批阅'
        } else if (this.form.stauts == 3) {
          this.form.stauts = '被退回'
        }
        // this.form.homeworkHref='http://localhost:8081/zkfz/zkolHomework/getFile?id='+res.data.data.hid;
        // this.form.answerHref='http://localhost:8081/zkfz/zkolHomework/getFile?id='+res.data.data.haid;
        // this.form.markingHref='http://localhost:8081/zkfz/zkolHomework/getFile?id='+res.data.data.hmid;

        this.form.homeworkHref =
          this.url + '/zkfz/zkolHomework/getFile?id=' + res.data.data.hid
        this.form.answerHref =
          this.url + '/zkfz/zkolHomework/getFile?id=' + res.data.data.haid
        this.form.markingHref =
          this.url + '/zkfz/zkolHomework/getFile?id=' + res.data.data.hmid
        console.log(this.form.attachment)
        if (res.data.data.haid !== null && res.data.data.haid !== '') {
          let fdata = {
            id: res.data.data.haid,
          }
          api.getFile(fdata).then(({ data }) => {
            let files = new File([data], this.form.answerAccessory, {
              type: this.form.answerAccessory.substring(
                this.form.answerAccessory.lastIndexOf('.')
              ),
            })
            console.log(files)
            this.file = files
          })
        }
      })
    },
    goBack() {
      window.history.go(-1)
    },
    handleChange(file, fileList) {
      this.file = file.raw
    },
    onSubmit(type) {
      console.log('-----')
      console.log(this.form)
      console.log(this.form.answerContent == '')
      if (
        (this.form.answerContent == null || this.form.answerContent == '') &&
        (this.flie == null || this.file == '')
      ) {
        this.$message({ type: 'error', message: `请做答案` })
        return
      } else {
        const formData = {
          homeworkId: this.$route.query.homeworkId,
          studentId: this.$route.query.studentId,
          // answerContent: this.form.answerContent,
          stauts: type,
          answerId: this.$route.query.answerId,
        }
        let filedata = this.file
        console.log('-----------')
        const file = this.file
        const size = file.size / 1024 / 1024
        if (size > this.form.attachmentSize) {
          this.$message({
            type: 'error',
            message: '操作失败，附件必须小于' + this.form.attachmentSize + 'M',
          })
          return
        }
        console.log('----' + this.form.attachmentSize)
        let flag = true
        if (this.file) {
          flag = this.beforeUpload(this.file)
        }
        if (!flag) {
          this.$message({ type: 'error', message: `只能上传word且不超过一个` })
          return
        }
        if (this.form.answerContent.length > 1003997) {
          this.$message({
            type: 'error',
            message: `富文本数据过大,图片大小等不能超过700K`,
          })
          return
        }
        if (this.isDisabled) {
          this.isDisabled = false //锁定
          api
            .saveStudentAnswer(formData, filedata, this.form.answerContent)
            .then((res) => {
              console.log(res.data.code)
              if (res.data.code === 100000) {
                this.$message({ type: 'success', message: '操作成功' })
                window.history.go(-1)
              } else {
                this.$message({ type: 'error', message: '操作失败' })
              }
              this.isDisabled = true //解除锁定
            })
        } else {
          this.$message({ type: 'error', message: '请勿重复操作' })
        }
      }
    },
    beforeUpload(file) {
      console.log(file.type)
      const allowList = [
        '.doc',
        'application/doc',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        '.docx',
        'application/msword',
      ]
      if (allowList.includes(file.type)) {
        console.log('----')
        return true
      } else {
        return false
      }
    },
  },
  created() {
    this.getUserByUid()
    const deitStyle = this.$route.query.edit_style
    this.editBtnStyle = deitStyle
    //判断是新增页面还是编辑页面
    if (deitStyle != '0') {
      // this.getParams()
      // this.getFile()
    }
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') 
    },
    url() {
      let url = window.location.protocol + '//' + window.location.host
      if (window.location.host == 'localhost:5001') {
        url = 'http://gz.hnjk.net'
      }
      return url
    },
  },
}
</script>

<style lang="scss" scoped>
.head {
  margin-bottom: 10px;
}
.clearfix:after {
  content: '';
  height: 0;
  line-height: 0;
  display: block;
  visibility: hidden;
  clear: both;
}
/deep/.ql-editor {
  min-height: 300px;
}
.student-info {
  display: flex;
  justify-content: space-around;
  border-bottom: 1px solid #cccccc;
  padding: 15px;
}
.download {
  color: #0099ff;
  text-decoration: none;
}
.send-back {
  position: fixed;
  width: 50%;
  left: 50%;
  transform: translateX(-50%);
  bottom: 30%;
  border: 1px solid black;
  background-color: white;
  padding: 10px;
}
.send-back-textarea {
  width: 100%;
  padding: 10px;
}
</style>
